/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState, useRef} from 'react'
import {MessageSquareDot, Megaphone} from 'lucide-react'
import {createPusherClient} from '../../helpers/pusherClient'
import useNotificationStore from '../../store/notificationStore'
import {useAuth} from '../../../app/modules/auth'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'

const animationStyles = `
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(384px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slideOutRight {
    from {
      opacity: 1;
      transform: translateX(0);
    }
    to {
      opacity: 0;
      transform: translateX(384px);
    }
  }

  /* Staggered entry animations - one by one */
  .toast-enter {
    animation: slideInRight 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  }

  .toast-enter:nth-child(1) {
    animation: slideInRight 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0s both;
  }

  .toast-enter:nth-child(2) {
    animation: slideInRight 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both;
  }

  .toast-enter:nth-child(3) {
    animation: slideInRight 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s both;
  }

  .toast-enter:nth-child(4) {
    animation: slideInRight 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) 0.4s both;
  }

  /* Staggered exit animations - one by one */
  .toast-exit {
    animation: slideOutRight 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards !important;
  }

  .toast-exit:nth-child(1) {
    animation: slideOutRight 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s forwards !important;
  }

  .toast-exit:nth-child(2) {
    animation: slideOutRight 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s forwards !important;
  }

  .toast-exit:nth-child(3) {
    animation: slideOutRight 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s forwards !important;
  }

  .toast-exit:nth-child(4) {
    animation: slideOutRight 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s forwards !important;
  }

  .toast-container {
    position: fixed;
    top: 1.5rem;
    right: 1.5rem;
    z-index: 50;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 360px;
    outline: none;
    pointer-events: none;
  }

  .toast-item {
    position: relative;
    background: white;
    border: none;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-radius: 0.75rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    width: 360px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .toast-item:hover {
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  .toast-header {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    font-weight: 600;
    font-size: 0.9rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  .message-header {
    background: #127289 !important;
  }

  .status-header {
    background: #f16263 !important;
  }

  .toast-header-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    overflow: hidden;
    flex: 1;
  }

  .toast-header-title span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.95rem;
  }

  .toast-header-title svg {
    stroke-width: 2.5;
    min-width: 18px;
  }

  .toast-body {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
    min-height: 70px;
    background: #fafbfc;
  }

  .toast-body-text {
    color: #475569;
    font-size: 0.875rem;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 500;
  }

  .toast-body-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
  }

  .toast-button {
    padding: 0.5rem 1rem;
    height: auto;
    min-height: 32px;
    font-size: 0.8rem;
    color: white;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .toast-button:active {
    transform: scale(0.98);
  }

  .message-button {
    background: #127289;
  }

  .message-button:hover {
    box-shadow: 0 4px 12px rgba(18, 114, 137, 0.4);
    transform: translateY(-2px);
  }

  .status-button {
    background: #d94a4c;
  }

  .status-button:hover {
    box-shadow: 0 4px 12px rgba(244, 162, 97, 0.4);
    transform: translateY(-2px);
  }

  .toast-close-btn {
    padding: 0.4rem;
    width: 28px;
    height: 28px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 0.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .toast-close-btn:hover {
    background-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }
`

interface ToastItem {
  id: string
  type: 'message' | 'status'
  data: any
  isExiting?: boolean
}

interface ToastConfig {
  type: 'message' | 'status'
  headerClass: string
  buttonClass: string
  duration: number
}

const TOAST_CONFIGS: Record<'message' | 'status', ToastConfig> = {
  message: {
    type: 'message',
    headerClass: 'message-header',
    buttonClass: 'message-button',
    duration: 8000,
  },
  status: {
    type: 'status',
    headerClass: 'status-header',
    buttonClass: 'status-button',
    duration: 8000,
  },
}

export function ClaimNotificationListener() {
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const {auth} = useAuth()
  const providerCode = currentUser?.providerCode
  const addNotification = useNotificationStore((state) => state.addNotification)
  const [toasts, setToasts] = useState<ToastItem[]>([])
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const timeoutRefs = useRef<Map<string, NodeJS.Timeout>>(new Map())

  const fetchClaimDetails = async (claimNumber: string) => {
    const apiUrl = `${process.env.REACT_APP_API_PROVIDER_URL}/api/Claims/GetByClaimNumber/${claimNumber}`
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${currentUser?.token}`,
        },
      })
      console.log('Claim details fetched:', response.data)
      return response.data
    } catch (error) {
      console.error('Error fetching claim details:', error)
      return null
    }
  }

  const playNotificationSound = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.currentTime = 0
    }
    const audio = new Audio('/media/sounds/notifications.mp3')
    audioRef.current = audio
    audio.play().catch((err) => console.error('Failed to play notification sound:', err))
  }

  const addToast = (newToast: ToastItem) => {
    const config = TOAST_CONFIGS[newToast.type]

    setToasts((prev) => {
      const next = [...prev, newToast]

      // Batasi maksimal 3 toast di viewport
      if (next.length > 3) {
        next.shift() // Hapus toast terlama
      }
      return next
    })

    // Clear timeout lama jika ada
    const existingTimeout = timeoutRefs.current.get(newToast.id)
    if (existingTimeout) {
      clearTimeout(existingTimeout)
    }

    // Set timeout baru untuk auto-close
    const timeoutId = setTimeout(() => {
      handleClose(newToast.id)
    }, config.duration)

    timeoutRefs.current.set(newToast.id, timeoutId)
  }

  useEffect(() => {
    if (!providerCode) {
      console.log('[Pusher] ⚠️ No provider code available')
      return
    }

    console.log('[Pusher] 🔄 Initializing Pusher...')
    console.log('[Pusher] Provider Code:', providerCode)

    const pusher = createPusherClient('ClaimNotification')

    // Subscribe untuk Message Channel
    const messageChannel = pusher.subscribe(`MessageChannel-ClaimNotification-${providerCode}`)
    console.log(
      '[Pusher:MessageChannel] Subscribed to:',
      `MessageChannel-ClaimNotification-${providerCode}`
    )
    messageChannel.bind_global((eventName: string, data: any) => {
      console.log(`[Pusher:MessageChannel] Event: ${eventName}`, data)
    })
    messageChannel.bind('Message-ClaimNotification', (data: {message: any}) => {
      console.log('[Pusher:MessageChannel] 📬 Received message notification:', data)
      const {
        claimNumber,
        customerName,
        remark,
        createdAt,
        createdBy,
        documentName,
        role,
        updatedBy,
        updatedAt,
        chatIsOpen,
      } = data.message

      // Add to store
      addNotification({
        type: 'chat',
        claimNumber: claimNumber || '',
        insurerName: data.message.insurerName || '',
        customerName: customerName || '',
        remark: remark || '',
        documentName: documentName && Array.isArray(documentName) ? documentName : [],
        role: role || '',
        createdBy: createdBy || '',
        createdAt: createdAt || new Date().toISOString(),
        updatedBy: updatedBy || '',
        updatedAt: updatedAt || new Date().toISOString(),
        chatIsOpen: chatIsOpen ?? false,
        isRead: false,
      })

      const newToast: ToastItem = {
        id: `message-${Date.now()}-${claimNumber}-${remark}`,
        type: 'message',
        data: data.message,
      }

      console.log('📩 Message Notification:', data.message)
      playNotificationSound()
      addToast(newToast)
    })

    // Subscribe untuk Status Update Channel
    const statusChannel = pusher.subscribe(`provider-update-case-${providerCode}`)
    console.log('[Pusher:StatusChannel] Subscribed to:', `provider-update-case-${providerCode}`)
    statusChannel.bind_global((eventName: string, data: any) => {
      console.log(`[Pusher:StatusChannel] Event: ${eventName}`, data)
    })
    statusChannel.bind('provider-message-update-case', (data: {message: any}) => {
      console.log('[Pusher:StatusChannel] 🔄 Received status notification:', data)
      const {ClaimNumber, StatusClaim} = data.message

      // Add to store
      addNotification({
        type: 'status',
        ClaimNumber,
        StatusClaim,
        createdAt: new Date().toISOString(),
        isRead: false,
      })

      const newStatusToast: ToastItem = {
        id: `status-${Date.now()}-${ClaimNumber}`,
        type: 'status',
        data: data.message,
      }

      console.log('🔄 Status Update Notification:', data.message)
      playNotificationSound()
      addToast(newStatusToast)
    })

    return () => {
      messageChannel.unbind_all()
      pusher.unsubscribe(`MessageChannel-ClaimNotification-${providerCode}`)
      statusChannel.unbind_all()
      pusher.unsubscribe(`provider-update-case-${providerCode}`)
      pusher.disconnect()

      // Clear all timeouts
      timeoutRefs.current.forEach((timeout) => clearTimeout(timeout))
      timeoutRefs.current.clear()
    }
  }, [providerCode])

  // Function to mark a notification as read by claimnumber and send a user updated notification
  const markNotificationAsRead = async (claimNumber: string) => {
    try {
      // const apiUrl = `https://localhost:7036/api/Provider/MarkNotificationAsRead`
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Provider/MarkNotificationAsRead`
      const userName = currentUser?.username || 'SYSTEM'

      // Build query parameters
      const queryParams = new URLSearchParams()
      queryParams.append('claimNumber', claimNumber)
      queryParams.append('userName', userName)

      const fullUrl = `${apiUrl}?${queryParams.toString()}`

      console.log('Marking notification as read with URL:', fullUrl)

      const response = await axios.post(
        fullUrl,
        {}, // Empty body since data is in query params
        {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      )

      if (response.data.isSuccess) {
        console.log('Notification marked as read successfully')
        return response.data
      }
    } catch (error) {
      console.error('Error marking notification as read:', error)
    }
  }

  const handleClick = async (toast: ToastItem) => {
    const claimNumber = toast.type === 'message' ? toast.data?.claimNumber : toast.data?.ClaimNumber

    if (!claimNumber) {
      console.error('No claim number found in toast data')
      return
    }

    try {
      const claimDetails = await fetchClaimDetails(claimNumber)

      if (claimDetails) {
        console.log('Navigating with claim details:', claimDetails)
        const treatmentType = claimDetails.treatmentType?.trim()

        if (treatmentType === 'Rawat inap') {
          navigate('/inpatient', {state: {claimDetails}})
        } else if (treatmentType === 'Rawat jalan') {
          navigate('/outpatient', {state: {claimDetails}})
        } else {
          console.warn('Unknown treatment type:', treatmentType)
          navigate('/inpatient', {state: {claimDetails}})
        }
      } else {
        console.error('Failed to fetch claim details, navigating with claim number only')
        navigate('/inpatient', {state: {claimNumber}})
      }

      if (toast.type === 'status') {
        await markNotificationAsRead(claimNumber)
      }
    } catch (error) {
      console.error('Error handling click:', error)
      navigate('/inpatient', {state: {claimNumber}})
    }

    handleClose(toast.id)
  }

  const handleClose = (id: string) => {
    // Start exit animation
    setToasts((prev) =>
      prev.map((toast) => (toast.id === id ? {...toast, isExiting: true} : toast))
    )

    // Remove after animation completes
    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id))
      const timeout = timeoutRefs.current.get(id)
      if (timeout) {
        clearTimeout(timeout)
        timeoutRefs.current.delete(id)
      }
    }, 700) // Match slideOutRight animation duration (0.7s = 700ms)
  }

  const getClaimNumber = (toast: ToastItem): string => {
    if (toast.type === 'message') {
      return toast.data.claimNumber || ''
    }
    return toast.data.ClaimNumber || ''
  }

  return (
    <>
      <style>{animationStyles}</style>
      <div className='toast-container'>
        {[...toasts].reverse().map((toast) => {
          const config = TOAST_CONFIGS[toast.type]
          const claimNumber = getClaimNumber(toast)

          return (
            <div
              key={toast.id}
              className={`toast-item ${toast.isExiting ? 'toast-exit' : 'toast-enter'}`}
            >
              {/* Header */}
              <div className={`toast-header ${config.headerClass}`}>
                <div className='toast-header-title'>
                  {toast.type === 'message' ? (
                    <MessageSquareDot size={18} className='flex-shrink-0' />
                  ) : (
                    <Megaphone size={18} className='flex-shrink-0' />
                  )}
                  <span>Claim: {claimNumber}</span>
                </div>
                <button
                  className='toast-close-btn'
                  onClick={() => handleClose(toast.id)}
                  aria-label='Close'
                >
                  ×
                </button>
              </div>

              {/* Body */}
              <div className='toast-body'>
                {toast.type === 'message' ? (
                  <>
                    <div className='toast-body-text'>{toast.data.remark}</div>
                    <div className='toast-body-actions'>
                      <button
                        className={`toast-button ${config.buttonClass}`}
                        onClick={() => handleClick(toast)}
                      >
                        View
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='toast-body-text'>
                      <span style={{fontWeight: 600}}>Update Status: </span>
                      {toast.data.StatusClaim}
                    </div>
                    <div className='toast-body-actions'>
                      <button
                        className={`toast-button ${config.buttonClass}`}
                        onClick={() => handleClick(toast)}
                      >
                        View
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
